import AttendanceTableForOffice from './AttendanceTableForOffice';
export default AttendanceTableForOffice;
